import getList from './get-list';
import getMine from './get-mine';

export default {
	getList,
	getMine
};
